import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        job: "border-transparent bg-[#ede9fe] text-[#6d28d9]",
        dc: "border-transparent bg-[#dbeafe] text-[#1d4ed8]",
        muted: "border-transparent bg-muted text-muted-foreground",
        warning: "border-transparent bg-[#fef3c7] text-[#92400e]",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "border-border text-foreground",
        scope: "border-transparent bg-muted text-[#475569]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({ className, variant, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
